import { useContext, useState } from 'react';
import './Nav.scss';
import bars from '../../../assets/img/bars-solid.svg';
import xmark from '../../../assets/img/xmark-solid.svg';
// import logo_eb from '../../../assets/img/logo_eb.png';
// import logo_eb from '../../../assets/img/eb_logo.png';
// import logo_ebHousing from '../../../assets/img/logo_ebhousing.png';
import logo_ebHousing from '../../../assets/img/logo_ebhousing0.png';
import { LangContext, CurrentLangContext } from '../../../contexts/contexts';
import { Link } from 'react-router-dom';
// import logo_ebHousing from '../../../assets/img/logo_eb_housing.png';
// import logo_ebHousing from '../../../assets/img/logo_ebhousingx.png';

function Nav() {
  let lastPositionNav = window.scrollY;
  const [hiddenNav, setHiddenNav] = useState(false);
  const [toggleBurgerMenu, setToggleBurgerMenu] = useState(false);
  const [sizeSuperior850, setSizeSuperior850] = useState(false);
  
  const [choiseLang, setChoiseLang] = useState(false);

  window.addEventListener('scroll', () => {
    if (lastPositionNav < window.scrollY && window.scrollY > (lastPositionNav +250)) {
      lastPositionNav = window.scrollY;
      // console.log("scroll to Top");
      setHiddenNav(true);
    }
    if (lastPositionNav > window.scrollY && window.scrollY < (lastPositionNav -250)) {
      lastPositionNav = window.scrollY;
      // console.log("scroll to Bottom");
      setHiddenNav(false);
    }

    if (window.innerWidth > 850) {
      setSizeSuperior850(true);
    } else {
      setSizeSuperior850(false)
      setHiddenNav(false);
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 850) {
      setToggleBurgerMenu(false);
      setSizeSuperior850(true);
    } else {
      setSizeSuperior850(false)
      setHiddenNav(false);
    }
  });
  
  const langs = useContext(LangContext);
  const navLangs = langs.nav;
  
  const CurrentLangC = useContext(CurrentLangContext);
  const currentLang = CurrentLangC[0];
  const setCurrentLang = CurrentLangC[1];
  // console.log(navLangs, navLangs.fr, navLangs[currentLang]);

  return (
    <div className="Nav"
      onMouseEnter={() => {
        setHiddenNav(false)
      }}
      onResize={() => {
        console.log("resizenav");
      }}
    >
      <div className="header_top">
        {/* <img src={logo_eb} alt="Logo eb" className="logo_eb" /> */}
        <Link to="/" className="link_logo_ebhousing"><img src={logo_ebHousing} alt="Logo eb housing" className="logo_eb_housing" /></Link>
        <div className="content_co-la-bu">
          {/* <div className={`connexion_content ${hiddenNav && sizeSuperior850 ? "hidden_nav" : "show_nav"}`}>
            <p className="connexion">Connexion</p>
            <i className="fa-solid fa-user"></i>
          </div> */}
          <div className="real_estate"
            style={{display: hiddenNav ? "flex" : "block", gap: hiddenNav && "5px"}}
          >
            <p className="real">Real</p>
            <p className="estate">estate</p>
          </div>
          <div className={`header_lang ${hiddenNav && sizeSuperior850 ? "hidden_nav" : "show_nav"}`}>
            <i className="fa-solid fa-globe"
              onClick={() => choiseLang ? setChoiseLang(false) : setChoiseLang(true)}
            ></i>
            {
              choiseLang && 
                <ul className="lang">
                  <li className="lang_fr"
                    onClick={() => {
                      setCurrentLang("fr");
                      setChoiseLang(false);
                    }}
                  >français</li>
                  <li className="lang_en"
                    onClick={() => {
                      setCurrentLang("en");
                      setChoiseLang(false);
                    }}
                  >english</li>
                </ul>
            }
          </div>
          <img src={!toggleBurgerMenu ? bars : xmark} alt="Burger menu" className="icon_burger"
            onClick={() => toggleBurgerMenu === true ? setToggleBurgerMenu(false) : setToggleBurgerMenu(true)}
          />
        </div>
      </div>
      <nav className={`${!toggleBurgerMenu ? "header_bottom" : "burger_nav"} ${hiddenNav && sizeSuperior850 ? "hidden_nav" : "show_nav"}`}>
        <ul>
          {
            navLangs[currentLang].map((i, k) => {
              return (
                <li key={k}>
                  <Link
                    to={
                      (i === "Accueil" || i === "Home") ? "/" :
                      (i === "Qui somme-nous" || i === "About us") ? "/about" :
                      (i === "Louer" || i === "Rent") ? "/rent" :
                      (i === "Acheter" || i === "Buy") ? "/buy" :
                      (i === "Avocats" || i === "Lawyers") ? "/lawyer" :
                      (i === "Contact" || i === "Contact") && "/contact"
                    }
                    onClick={() => {setToggleBurgerMenu(false)}}
                  >{i}</Link>
                </li>
              )
            })
          }
        </ul>
      </nav>
    </div>
  );
}

export default Nav;